angular.module('dnecom')
    .controller('CronManagerDetailsController', ["$scope", "$window", "notifications", function($scope, $window, notifications) {
        $scope.flashError = TemplateData.value('flashError');
        $scope.flashSuccess = TemplateData.value('flashSuccess');

        if ($scope.flashError && $scope.flashError.length > 0) {
            _.each($scope.flashError, function (message) {
                notifications.danger(message);
            });
        }

        if ($scope.flashSuccess && $scope.flashSuccess.length > 0) {
            _.each($scope.flashSuccess, function (message) {
                notifications.success(message);
            });
        }
    }]);